import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import MarkunreadOutlinedIcon from "@mui/icons-material/MarkunreadOutlined";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import { SvgIcon, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { CommonService } from "../../Service/CommonService";
import { OrderApiService } from "../../Service/OrderApiService";
import { useNotificationWebSocket } from "../../Websocket/NotificationProvider";
import { InventoryApiService } from "../../Service/InventoryApiService";
import { Service } from "../../Service/ApiService";
import { useHistory, useLocation } from "react-router";

interface Notification {
  id: string;
  createdBy: string;
  createdDate: string;
  inventoryName: string | null;
  inventorySellRequestId: string | null;
  isActive: boolean;
  isDelete: boolean;
  isSeen: boolean;
  modifiedBy: string;
  modifiedDate: string;
  orderRequestId: string | null;
  orderStatus: string;
  offerRequestId: string | null;
  quantity: number | null;
  requestType: string;
  sampleRequestId: string | null;
  userId: string;
  fileName: string;
  companyId: string;
  requestNumber: string;
  wantedToBuyId: string | null;
  customerServiceRequestId: string | null;
}

interface NotificationComponentProps {
  userId: string;
}

const NotificationComponent: React.FC<NotificationComponentProps> = ({
  userId,
}) => {
  const { notificationWebSocketService } = useNotificationWebSocket();
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [isConnected, setIsConnected] = useState<boolean>(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [notificationCount, setNotificationCount] = useState<number>(0);
  const reconnectTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [toggleNotification, setToggleNotification] = useState(false);
  const [originalToggleValue, setOriginalToggleValue] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const handleOpenSetting = () => {
    setOriginalToggleValue(toggleNotification); //store original value
    setIsSettingsOpen(true);
  };

  const handleBack = () => {
    setIsSettingsOpen(false);
    setToggleNotification(originalToggleValue); // restore old value
    setHasChanges(false);
  };

  const handleNotificationToggleChange = (e) => {
    const newValue = e.target.checked;

    if (newValue !== originalToggleValue) {
      setHasChanges(true);
      console.log("Value changed!");
    } else {
      setHasChanges(false);
      console.log("Value reverted!");
    }

    setToggleNotification(newValue);
  };

  const handleSaveChanges = () => {
    setIsSettingsOpen(false);
    saveWantedToBuyNotificationsToggleValue();
  };

  const handleDropdownToggle = async (isOpen: boolean) => {
    setIsDropdownOpen(isOpen);
    if (!isOpen) {
      if (notificationCount > 0) {
        await OrderApiService.updateIsSeenFlag();
        fetchAllNotifications();
      }
      setNotificationCount(0);
    }
  };

  // const handleNotification = useCallback(
  //   (data: string | object) => {
  //     try {
  //       console.log("Raw notification data:", data);
  //       const newNotification: Notification =
  //         typeof data === "string" ? JSON.parse(data) : (data as Notification);
  //       console.log("Parsed notification data:", newNotification);

  //       //add notification
  //       setNotifications((prevNotifications) => [
  //         newNotification,
  //         ...prevNotifications,
  //       ]);

  //       //increase the notification count
  //       setNotificationCount((prevCount) => prevCount + 1);
  //     } catch (error) {
  //       console.error("Error handling notification:", error);
  //     }
  //   },
  //   [isDropdownOpen]
  // );

  // const subscribeToNotifications = useCallback(() => {
  //   notificationWebSocketService.subscribeToUserChannel(
  //     userId,
  //     handleNotification
  //   );
  // }, [userId, handleNotification]);

  // const connectWebSocket = useCallback(() => {
  //   if (
  //     notificationWebSocketService.client &&
  //     notificationWebSocketService.client.connected
  //   ) {
  //     if (!isConnected) {
  //       setIsConnected(true);
  //       subscribeToNotifications();
  //     }
  //   } else {
  //     notificationWebSocketService.connect(
  //       () => {
  //         setIsConnected(true);
  //         subscribeToNotifications();
  //       },
  //       () => {
  //         setIsConnected(false);
  //         // Attempt to reconnect after 5 seconds
  //         reconnectTimeoutRef.current = setTimeout(connectWebSocket, 1000);
  //       }
  //     );
  //   }
  // }, [subscribeToNotifications, isConnected]);

  // useEffect(() => {
  //   connectWebSocket();

  //   return () => {
  //     if (reconnectTimeoutRef.current) {
  //       clearTimeout(reconnectTimeoutRef.current);
  //     }
  //   };
  // }, [connectWebSocket]);

  useEffect(() => {

    //fetch setting value for wanted to buy notification
    fetchWantedToBuyNotificationsToggleValue();

    const module = "notificationModule";

    const callbackMethod = (data: any) => {
      console.log("Received data:", data);
      try {
        console.log("Raw notification data:", data);
        const newNotification: Notification =
          typeof data === "string" ? JSON.parse(data) : (data as Notification);
        console.log("Parsed notification data:", newNotification);

        //add notification
        setNotifications((prevNotifications) => [
          newNotification,
          ...prevNotifications,
        ]);

        //increase the notification count
        setNotificationCount((prevCount) => prevCount + 1);
      } catch (error) {
        console.error("Error handling notification:", error);
      }
    };

    notificationWebSocketService.subscribe(module, callbackMethod);

    return () => {
      // Clean up subscriptions if necessary
    };
  }, [notificationWebSocketService]);

  /*const getUnseenMessageCount = async () => {
    try {
      const response = await OrderApiService.getUnseenMessageCount();
      console.log("This is your notification count: " + response.data);
      setNotificationCount(response.data);
    } catch (error) {
      console.log(
        "Error occurring while getting count of unseen messages",
        error
      );
    }
  };

  const fetchAllNotifications = async () => {
    try {
      const response = await OrderApiService.getAllNotifications();
      console.log("These are your notifications: ", response);
      setNotifications(response.data);
    } catch (error) {
      console.log("Error occurring while fetching all notifications", error);
    }
  };*/

  const getUnseenMessageCount = async () => {
    try {
      const response = await OrderApiService.getUnseenMessageCount();
      let count = response.data;

      if (!toggleNotification) {
        // When toggle OFF → remove WTB & MarkInterested unseen count
        count = notifications.filter((n: any) => {
          const isWTB =
            n.requestType === "WANTED_TO_BUY" ||
            n.requestType === "MARK_INTRESTED_WANTED_TO_BUY";

          if (!n.isSeen && isWTB) return false;
          return true;
        }).length;
      }

      setNotificationCount(count);
    } catch (error) {
      console.log("Error occurring while getting count of unseen messages", error);
    }
  };

  const fetchAllNotifications = async () => {
    try {
      const response = await OrderApiService.getAllNotifications();
      let all = response.data;

      // FILTER LOGIC HERE
      let filtered = all.filter((n: any) => {
        const isWTB =
          n.requestType === "WANTED_TO_BUY" ||
          n.requestType === "MARK_INTRESTED_WANTED_TO_BUY";

        if (!toggleNotification) {
          // Toggle OFF → hide NEW notifications only
          if (!n.isSeen && isWTB) return false;
        }
        return true;
      });
      setNotifications(filtered);
    } catch (error) {
      console.log("Error occurring while fetching all notifications", error);
    }
  };


  const fetchWantedToBuyNotificationsToggleValue = async () => {
    try {
      const response = await Service.getWantedToBuyNotificationToggleValue();
      setToggleNotification(response?.data);
    } catch (error) {
      console.log("Error occurring while fetching all notifications", error);
    }
  };

  const saveWantedToBuyNotificationsToggleValue = async () => {
    try {
      const response = await Service.saveWantedToBuyNotificationToggleValue(toggleNotification);
      setOriginalToggleValue(response?.data);
      setHasChanges(false);
      CommonService.Toast.fire({
        title:"Setting updated successfully",
        icon: "success"
      });
    } catch (error) {
      console.log("Error occurring while fetching all notifications", error);
      setToggleNotification(originalToggleValue);
      setHasChanges(false);
      CommonService.Toast.fire({
        title:"There is some issue occurred while saving notification settings!",
        icon: "error"
      });
    }
  };

  const downloadExportFile = async (companyId: any, userId: any, fileName: any, id: any) => {
    try {
      const response: any = await InventoryApiService.downloadExportFile(companyId, userId, fileName, id);
  
      // Open the URL in a new tab without affecting the current page
      window.open(response.data, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const downloadFacilitiesExportFile = async (companyId: any, userId: any, fileName: any, id: any) => {
    try {
      const response: any = await InventoryApiService.downloadFacilitiesExportFile(companyId, userId, fileName, id);
  
      // Open the URL in a new tab without affecting the current page
      window.open(response.data, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const downloadOwnershipTransferExportFile = async (companyId: any, userId: any, fileName: any, id: any) => {
    try {
      const response: any = await InventoryApiService.downloadOwnershipTransferExportFile(companyId, userId, fileName, id);

      // Open the URL in a new tab without affecting the current page
      window.open(response.data, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const downloadLogisticRequestExportFile = async (companyId: any, userId: any, fileName: any, id: any) => {
    try {
      const response: any = await InventoryApiService.downloadLogisticRequestExportFile(companyId, userId, fileName, id);
  
      // Open the URL in a new tab without affecting the current page
      window.open(response.data, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const downloadMarketValueReport = async (companyId: any, userId: any, fileName: any) => {
    try {
      const response: any = await InventoryApiService.downloadMarketValueExportFile(companyId, userId, fileName);
  
      // Open the URL in a new tab without affecting the current page
      window.open(response.data, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const downloadReport = async (userId: any, fileName: any, requestNumber:any) => {
    try {
      const response: any = await InventoryApiService.downloadReport(userId, fileName, requestNumber);
  
      // Open the URL in a new tab without affecting the current page
      window.open(response.data, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const downloadCompanyReport = async (companyId: any, userId: any, fileName: any, id: any) => {
    try {
      const response: any = await Service.downloadCompanyReport(companyId, userId, fileName, id);

      // Open the URL in a new tab without affecting the current page
      window.open(response.data, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  
  const downloadCompanyInventorySummaryReport = async (companyId: any, userId: any, fileName: any, id: any) => {
    try {
      const response: any = await InventoryApiService.downloadCompanyInventorySummaryReport(companyId, userId, fileName, id);

      // Open the URL in a new tab without affecting the current page
      window.open(response.data, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const downloadCompanyBillingActivityReport = async (companyId: any, userId: any, fileName: any, id: any) => {
    try {
      const response: any = await InventoryApiService.downloadCompanyBillingActivityReport(companyId, userId, fileName, id);

      // Open the URL in a new tab without affecting the current page
      window.open(response.data, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const downloadTTBReport = async (companyId: any, userId: any, fileName: any, id: any) => {
    try {
      const response: any = await InventoryApiService.downloadTTBReport(companyId, userId, fileName, id);
      // Open the URL in a new tab without affecting the current page
      window.open(response.data, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const downloadServiceRequestBillingReport = async (companyId: any, userId: any, fileName: any, id: any) => {
    try {
      const response: any = await InventoryApiService.downloadServiceRequestBillingReport(companyId, userId, fileName, id);
       window.open(response.data, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const downloadCompanyBulkInventoryUploadReport = async (companyId: any, userId: any, fileName: any, id: any) => {
    try {
      const response: any = await InventoryApiService.downloadCompanyBulkInventoryUploadReport(companyId, userId, fileName, id);

      // Open the URL in a new tab without affecting the current page
      window.open(response.data, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchAllNotifications();
    getUnseenMessageCount();
  }, [toggleNotification]);

  const renderNotificationMessage = (notification: Notification): any => {
    const {
      requestType,
      orderStatus,
      quantity,
      inventoryName,
      fileName,
      requestNumber,
      wantedToBuyId,
      customerServiceRequestId,
    } = notification;

    const cleanRequestType =
      typeof requestType === "string" ? requestType.trim() : "";

    switch (cleanRequestType) {
      case "ORDER_REQUEST":
        return `Order request for ${quantity} barrels is ${orderStatus
          ?.toLowerCase()
          .replace("_", " ")}.`;
      case "SELL_REQUEST":
        return `Inventory sell request for '${fileName?.slice(
          4
        )}' is ${orderStatus?.toLowerCase().replace("_", " ")}.`;
      case "SAMPLE_REQUEST":
        return `Sample request for ${
          inventoryName || "unknown inventory"
        } is ${orderStatus?.toLowerCase().replace("_", " ")}.`;
      case "OFFER_REQUEST":
        return `Offer request for ${
          inventoryName || "unknown inventory"
        } is ${orderStatus?.toLowerCase().replace("_", " ")}.`;
      case "EXPORT_REQUEST":
        return (
          <span
            onClick={() =>
              downloadExportFile(
                notification.companyId,
                notification.userId,
                notification.fileName,
                notification.id
              )
            }
            style={{ cursor: "pointer" }}
          >
            Your exported file is ready for download! <u>Click to download</u>
          </span>
        );
      case "FACILITIES_EXPORT_REQUEST":
        return (
          <span
            onClick={() =>
              downloadFacilitiesExportFile(
                notification.companyId,
                notification.userId,
                notification.fileName,
                notification.id
              )
            }
            style={{ cursor: "pointer" }}
          >
            Your exported facilities report file is ready for download! <u>Click to download</u>
          </span>
      );
      case "OWNERSHIP_TRANSFER_REQUEST":
        return (
          <span
            onClick={() =>
              downloadOwnershipTransferExportFile(
                notification.companyId,
                notification.userId,
                notification.fileName,
                notification.id
              )
            }
            style={{ cursor: "pointer" }}
          >
            Your exported ownership transfer report file is ready for download! <u>Click to download</u>
          </span>
      );
      case "EXPORT_MARKET_VALUE_REPORT":
        return (
          <span
           onClick={() =>
              downloadMarketValueReport(
                notification?.companyId,
                notification?.userId,
                notification?.fileName
              )
            }
            style={{ cursor: "pointer" }}
          >
            Your exported market value file is ready for download!{" "}
            <u>Click to download</u>
          </span>
        );
      case "CUSTOMER_SERVICE_REQUEST":
        return `The Sell Request #${requestNumber} has been updated by a ${
          CommonService.isAdmin() ? "Account Owner User" : "super admin"
        }`;
      case "BARREL_PROOFING_REQUEST":
        return (
          <span
            onClick={() =>
              downloadReport(
                notification?.userId,
                notification?.fileName,
                notification?.requestNumber
              )
            }
            style={{ cursor: "pointer" }}
          >
            Your exported Barrel Proofing Value file is ready for download!{" "}
            <u>Click to download</u>
          </span>
        );
      case "BARREL_VALUATION_REQUEST":
        return (
          <span
            onClick={() =>
              downloadReport(
                notification?.userId,
                notification?.fileName,
                notification?.requestNumber
              )
            }
            style={{ cursor: "pointer" }}
          >
            Your exported Container Valuation file is ready for download!{" "}
            <u>Click to download</u>
          </span>
        );
      case "WANTED_TO_BUY":
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (wantedToBuyId) {
                history.push(`/user/wanted-to-buy`);
              } else {
                console.warn(
                  "WantedToBuy ID missing for notification:",
                  notification
                );
              }
            }}
          >
            You have a matching inventory for the Wanted to Buy Request{" "}
            <b>{inventoryName}</b>
          </span>
        );
     case "MARK_INTRESTED_WANTED_TO_BUY":
      return (
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            history.replace("/_temp");
            setTimeout(() => {
              history.push(
                `/master/view-customer-service-request/${customerServiceRequestId}`
              );
            }, 10);
          }}
        >
          Matching inventory are now available for Wanted to Buy request{" "}
          <b>#{requestNumber}</b>
        </span>
      );
      case "LOGISTIC_EXPORT_REQUEST":
        return (
          <span
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              downloadLogisticRequestExportFile(
                notification.companyId,
                notification.userId,
                notification.fileName,
                notification.id
              )
            }}
            style={{ cursor: "pointer" }}
          >
            Your exported logistic report file is ready for download! <u>Click to download</u>
          </span>
      );
      case "TASTING_REQUEST":
      return (
        <span
          onClick={() =>
            downloadReport(
              notification?.userId,
              notification?.fileName,
              notification?.requestNumber
            )
          }
          style={{ cursor: "pointer" }}
        >
          Your exported Tasting detail file is ready for download!{" "}
          <u>Click to download</u>
        </span>
      );
      case "COMPANIES_EXPORT_REQUEST":
        return (
          <span
            onClick={() =>
              downloadCompanyReport(
                notification.companyId,
                notification.userId,
                notification.fileName,
                notification.id
              )
            }
            style={{ cursor: "pointer" }}
          >
            Your exported companies report file is ready for download! <u>Click to download</u>
          </span>
      );
      case "COMPANY_INVENTORY_SUMMARY_EXPORT_REQUEST":
        return (
          <span
            onClick={() =>
              downloadCompanyInventorySummaryReport(
                notification.companyId,
                notification.userId,
                notification.fileName,
                notification.id
              )
            }
            style={{ cursor: "pointer" }}
          >
            Your exported account owner inventory summary report file is ready for download! <u>Click to download</u>
          </span>
      );
      case "COMPANY_BILLING_ACTIVITY_EXPORT_REQUEST":
        return (
          <span
            onClick={() =>
              downloadCompanyBillingActivityReport(
                notification.companyId,
                notification.userId,
                notification.fileName,
                notification.id
              )
            }
            style={{ cursor: "pointer" }}
          >
            Your exported account owner billing activity report file is ready for download! <u>Click to download</u>
          </span>
      );
      case "TTB_EXPORT_REQUEST":
        return (
          <span
            onClick={() =>
              downloadTTBReport(
                notification.companyId,
                notification.userId,
                notification.fileName,
                notification.id
              )
            }
            style={{ cursor: "pointer" }}
          >
            Your exported ttb report file is ready for download! <u>Click to download</u>
          </span>
      );
      case "SERVICE_REQUEST_BILLING_EXPORT_REQUEST":
        return (
          <span
            onClick={() =>
              downloadServiceRequestBillingReport(
                notification.companyId,
                notification.userId,
                notification.fileName,
                notification.id
              )
            }
            style={{ cursor: "pointer" }}
          >
            Your Service Request Billing report is ready for download! <u>Click to download</u>
             </span>
      );
      case "BULK_INVENTORY_UPLOAD_EXPORT_REQUEST":
        return (
          <span
            onClick={() =>
              downloadCompanyBulkInventoryUploadReport(
                notification.companyId,
                notification.userId,
                notification.fileName,
                notification.id
              )
            }
            style={{ cursor: "pointer" }}
          >
            Your exported bulk inventory upload report file is ready for download! <u>Click to download</u>
          </span>
      );
      default:
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => CommonService.isAdmin() ? history.push("/master/insurance-pricing") : history.push("/user/barrel-market-value") }
          >
            {CommonService.isAdmin()
              ? "Reminder: Update barrel market value before start of Next Quarter"
              : "Price update window for current quarter is now open. Please update custom barrel prices"}
          </span>
        );
    }
  };

  return (
    <Dropdown onToggle={handleDropdownToggle}>
      <Dropdown.Toggle
        variant="basic"
        className="rounded-circle"
        id="dropdown-basic"
      >
        <NotificationsNoneRoundedIcon />
        {notificationCount > 0 && (
          <span
            className="msg-count"
            aria-label={`${notificationCount} notifications`}
          >
          {notificationCount > 99 ? "99+" : notificationCount}
          </span>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu align="start" className="pt-0">
        <div className="dropdown-header">
          <div>
            {!isSettingsOpen ? (
              <p className="heading">
                Notifications
              </p>
              ):(
                <button className="back-btn" onClick={handleBack}>
                  <svg className="align-middle" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.76561 9.4849C7.80045 9.51974 7.82809 9.5611 7.84694 9.60662C7.8658 9.65214 7.8755 9.70094 7.8755 9.75021C7.8755 9.79948 7.8658 9.84827 7.84694 9.8938C7.82809 9.93932 7.80045 9.98068 7.76561 10.0155C7.73077 10.0504 7.6894 10.078 7.64388 10.0969C7.59836 10.1157 7.54957 10.1254 7.5003 10.1254C7.45102 10.1254 7.40223 10.1157 7.35671 10.0969C7.31119 10.078 7.26982 10.0504 7.23498 10.0155L3.48498 6.26552C3.45012 6.23069 3.42246 6.18934 3.40359 6.14381C3.38471 6.09829 3.375 6.04949 3.375 6.00021C3.375 5.95093 3.38471 5.90213 3.40359 5.85661C3.42246 5.81108 3.45012 5.76972 3.48498 5.7349L7.23498 1.9849C7.30535 1.91453 7.40078 1.875 7.5003 1.875C7.59981 1.875 7.69524 1.91453 7.76561 1.9849C7.83597 2.05526 7.8755 2.1507 7.8755 2.25021C7.8755 2.34972 7.83597 2.44516 7.76561 2.51552L4.28045 6.00021L7.76561 9.4849Z" fill="#0C3344"/>
                  </svg>
                  <span>Back</span>
                </button>
              )}
          </div>
          <div className="header-right">
            {!CommonService.isWarehouse() && !isSettingsOpen && (
              <button onClick={handleOpenSetting} style={{ cursor: "pointer" }}>
                <svg className="align-baseline" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.9988 3.7488C5.55379 3.7488 5.11878 3.88076 4.74877 4.12799C4.37876 4.37523 4.09037 4.72663 3.92007 5.13776C3.74977 5.5489 3.70522 6.0013 3.79203 6.43775C3.87885 6.87421 4.09314 7.27512 4.40781 7.58979C4.72248 7.90446 5.12339 8.11875 5.55985 8.20557C5.99631 8.29239 6.44871 8.24783 6.85984 8.07753C7.27097 7.90723 7.62237 7.61884 7.86961 7.24883C8.11684 6.87882 8.2488 6.44381 8.2488 5.9988C8.24818 5.40225 8.01093 4.83032 7.58911 4.4085C7.16728 3.98667 6.59535 3.74942 5.9988 3.7488ZM5.9988 7.4988C5.70213 7.4988 5.41212 7.41083 5.16545 7.24601C4.91877 7.08118 4.72651 6.84692 4.61298 6.57283C4.49945 6.29874 4.46975 5.99714 4.52762 5.70617C4.5855 5.41519 4.72836 5.14792 4.93814 4.93814C5.14792 4.72836 5.41519 4.5855 5.70617 4.52762C5.99714 4.46975 6.29874 4.49945 6.57283 4.61298C6.84692 4.72651 7.08118 4.91877 7.24601 5.16545C7.41083 5.41212 7.4988 5.70213 7.4988 5.9988C7.4988 6.39663 7.34077 6.77816 7.05946 7.05946C6.77816 7.34077 6.39663 7.4988 5.9988 7.4988ZM10.1238 6.10005C10.1257 6.03255 10.1257 5.96505 10.1238 5.89755L10.8232 5.0238C10.8598 4.97793 10.8852 4.92408 10.8973 4.8666C10.9093 4.80911 10.9077 4.7496 10.8926 4.69286C10.7779 4.2619 10.6064 3.84811 10.3826 3.46239C10.3532 3.41192 10.3126 3.36898 10.2637 3.337C10.2149 3.30502 10.1593 3.28488 10.1013 3.27818L8.98943 3.15443C8.94318 3.10568 8.8963 3.0588 8.8488 3.0138L8.71755 1.89911C8.7108 1.84109 8.69059 1.78544 8.65852 1.73661C8.62646 1.68778 8.58343 1.64712 8.53286 1.61786C8.14701 1.39443 7.73325 1.2231 7.30239 1.10833C7.24562 1.09324 7.18609 1.09169 7.1286 1.10382C7.07112 1.11596 7.01729 1.14142 6.97146 1.17818L6.10005 1.8738C6.03255 1.8738 5.96505 1.8738 5.89755 1.8738L5.0238 1.17583C4.97793 1.13916 4.92408 1.11378 4.8666 1.10173C4.80911 1.08968 4.7496 1.0913 4.69286 1.10646C4.26196 1.22131 3.8482 1.39281 3.46239 1.61646C3.41192 1.64577 3.36898 1.68645 3.337 1.73528C3.30502 1.78411 3.28488 1.83972 3.27818 1.89771L3.15443 3.01146C3.10568 3.05802 3.0588 3.10489 3.0138 3.15208L1.89911 3.28005C1.84109 3.2868 1.78544 3.30702 1.73661 3.33908C1.68778 3.37115 1.64712 3.41418 1.61786 3.46474C1.39443 3.8506 1.2231 4.26435 1.10833 4.69521C1.09324 4.75198 1.09169 4.81151 1.10382 4.869C1.11596 4.92648 1.14142 4.98031 1.17818 5.02614L1.8738 5.89755C1.8738 5.96505 1.8738 6.03255 1.8738 6.10005L1.17583 6.9738C1.13916 7.01968 1.11378 7.07352 1.10173 7.13101C1.08968 7.18849 1.0913 7.248 1.10646 7.30474C1.22111 7.73571 1.39261 8.1495 1.61646 8.53521C1.64577 8.58568 1.68645 8.62862 1.73528 8.6606C1.78411 8.69258 1.83972 8.71273 1.89771 8.71943L3.00958 8.84318C3.05614 8.89193 3.10302 8.9388 3.15021 8.9838L3.28005 10.0985C3.2868 10.1565 3.30702 10.2122 3.33908 10.261C3.37115 10.3098 3.41418 10.3505 3.46474 10.3797C3.8506 10.6032 4.26435 10.7745 4.69521 10.8893C4.75198 10.9044 4.81151 10.9059 4.869 10.8938C4.92648 10.8816 4.98031 10.8562 5.02614 10.8194L5.89755 10.1238C5.96505 10.1257 6.03255 10.1257 6.10005 10.1238L6.9738 10.8232C7.01968 10.8598 7.07352 10.8852 7.13101 10.8973C7.18849 10.9093 7.248 10.9077 7.30474 10.8926C7.73571 10.7779 8.1495 10.6064 8.53521 10.3826C8.58568 10.3532 8.62862 10.3126 8.6606 10.2637C8.69258 10.2149 8.71273 10.1593 8.71943 10.1013L8.84318 8.98943C8.89193 8.94318 8.9388 8.8963 8.9838 8.8488L10.0985 8.71755C10.1565 8.7108 10.2122 8.69059 10.261 8.65852C10.3098 8.62646 10.3505 8.58343 10.3797 8.53286C10.6032 8.14701 10.7745 7.73325 10.8893 7.30239C10.9044 7.24562 10.9059 7.18609 10.8938 7.1286C10.8816 7.07112 10.8562 7.01729 10.8194 6.97146L10.1238 6.10005ZM9.36911 5.79536C9.37708 5.93087 9.37708 6.06673 9.36911 6.20224C9.36353 6.29501 9.3926 6.38656 9.45068 6.45911L10.1158 7.29021C10.0395 7.53277 9.94178 7.76807 9.8238 7.99333L8.76443 8.11333C8.67217 8.12357 8.58699 8.16767 8.52536 8.23708C8.43513 8.33856 8.33903 8.43467 8.23755 8.5249C8.16814 8.58652 8.12404 8.6717 8.1138 8.76396L7.99615 9.8224C7.77091 9.94043 7.5356 10.0382 7.29302 10.1144L6.46146 9.44927C6.39492 9.3961 6.31226 9.36717 6.22708 9.36724H6.20458C6.06907 9.37521 5.93322 9.37521 5.79771 9.36724C5.70493 9.36165 5.61339 9.39072 5.54083 9.4488L4.70739 10.1144C4.46483 10.0381 4.22953 9.94037 4.00427 9.8224L3.88427 8.76443C3.87403 8.67217 3.82994 8.58699 3.76052 8.52536C3.65904 8.43513 3.56294 8.33903 3.47271 8.23755C3.41108 8.16814 3.3259 8.12404 3.23364 8.1138L2.17521 7.99568C2.05717 7.77044 1.95944 7.53514 1.88318 7.29255L2.54833 6.46099C2.60641 6.38843 2.63548 6.29689 2.62989 6.20411C2.62193 6.06861 2.62193 5.93275 2.62989 5.79724C2.63548 5.70446 2.60641 5.61292 2.54833 5.54036L1.88318 4.70739C1.9595 4.46483 2.05723 4.22953 2.17521 4.00427L3.23318 3.88427C3.32543 3.87403 3.41061 3.82994 3.47224 3.76052C3.56247 3.65904 3.65857 3.56294 3.76005 3.47271C3.82974 3.41104 3.87402 3.32567 3.88427 3.23318L4.00193 2.17521C4.22716 2.05717 4.46247 1.95944 4.70505 1.88318L5.53661 2.54833C5.60917 2.60641 5.70072 2.63548 5.79349 2.62989C5.929 2.62193 6.06486 2.62193 6.20036 2.62989C6.29314 2.63548 6.38468 2.60641 6.45724 2.54833L7.29021 1.88318C7.53277 1.9595 7.76807 2.05723 7.99333 2.17521L8.11333 3.23318C8.12357 3.32543 8.16767 3.41061 8.23708 3.47224C8.33856 3.56247 8.43467 3.65857 8.5249 3.76005C8.58652 3.82947 8.6717 3.87356 8.76396 3.8838L9.8224 4.00146C9.94043 4.22669 10.0382 4.462 10.1144 4.70458L9.44927 5.53614C9.39063 5.60931 9.36153 5.7018 9.36771 5.79536H9.36911Z" fill="#0C3344"/>
                </svg>
                <span>Settings</span>
              </button>
            )}

            {isSettingsOpen && (
              <>
                {hasChanges && (
                  <button className="save-btn" onClick={handleSaveChanges}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.7655 3.64052L4.76552 9.64052C4.73069 9.67539 4.68934 9.70305 4.64381 9.72192C4.59829 9.74079 4.54949 9.7505 4.50021 9.7505C4.45093 9.7505 4.40213 9.74079 4.35661 9.72192C4.31108 9.70305 4.26972 9.67539 4.2349 9.64052L1.6099 7.01552C1.53953 6.94516 1.5 6.84972 1.5 6.75021C1.5 6.6507 1.53953 6.55526 1.6099 6.4849C1.68026 6.41453 1.7757 6.375 1.87521 6.375C1.97472 6.375 2.07016 6.41453 2.14052 6.4849L4.50021 8.84505L10.2349 3.1099C10.3053 3.03953 10.4007 3 10.5002 3C10.5997 3 10.6952 3.03953 10.7655 3.1099C10.8359 3.18026 10.8754 3.2757 10.8754 3.37521C10.8754 3.47472 10.8359 3.57016 10.7655 3.64052Z" fill="#0C3344"/>
                    </svg>
                    <span>Save Changes</span>
                  </button>
                )}
              </>
            )}
          </div>
        </div>
        <div className="dropdown-inner">
          {isSettingsOpen ? (
            <>
              <Dropdown.Item className="setting-wrapper">
                <p className="setting-header">Notification Alerts</p>
                <div className='notification-toggle-wrapper'>
                  <div className="d-flex align-items-center">
                   <label className="toggle-switch" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={toggleNotification}
                      onChange={handleNotificationToggleChange}
                      onClick={(e) => e.stopPropagation()} 
                    />
                    <div className='switch-inner' style={{
                      backgroundColor: toggleNotification ? '#9E874A' : 'transparent',
                      borderColor: toggleNotification ? '#9E874A' : '#DEE2E6',
                    }}>
                      <div className='switch-toggler' style={{
                        left: toggleNotification ? '22px' : '2px',
                        backgroundColor: toggleNotification ? '#fff' : '#BFBFBF',
                      }} />
                    </div>
                    <span className='switch-label' style={{ fontSize: "18px" }}>
                      Wanted To Buy
                    </span>
                  </label>
                  </div>
                </div>
              </Dropdown.Item>
            </>
          ) : (
            <>
              {notifications.length === 0 ? (
                <Dropdown.Item disabled>No notifications</Dropdown.Item>
              ) : (
                notifications.map((notification, index) => (
                  <React.Fragment key={notification.id}>
                    <Dropdown.Item href="#/action-1">
                      <div className="notification-msg-wrapper d-flex flex-column flex-sm-row w-100">
                        <div className="notification-msg d-inline-flex me-3">
                          {!notification.isSeen && (
                            <SvgIcon
                              component={MarkunreadOutlinedIcon}
                              sx={{
                                color: "#000000",
                                marginRight: "8px",
                              }}
                            />
                          )}

                          {notification.isSeen && (
                            <SvgIcon
                              component={DraftsOutlinedIcon}
                              sx={{
                                color: "#A1A1A1",
                                marginRight: "8px",
                              }}
                            />
                          )}

                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: notification.isSeen ? 400 : 700,
                              fontSize: "14px",
                              maxWidth: "275px",
                              textWrap: "wrap",
                              wordWrap: "break-word",
                              "&:hover": { color: "#191f25" },
                            }}
                          >
                            {renderNotificationMessage(notification)}
                          </Typography>
                        </div>
                        <div className="notification-time d-inline-flex flex-sm-column align-items-end ms-auto">
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#A1A1A1",
                              fontWeight: 600,
                              fontSize: "13px",
                            }}
                          >
                            {CommonService.formatDate(notification.createdDate)}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#A1A1A1",
                              fontWeight: 600,
                              fontSize: "13px",
                              marginLeft: "6px",
                            }}
                          >
                            {CommonService.formatTime(notification.createdDate)}
                          </Typography>
                        </div>
                      </div>
                    </Dropdown.Item>
                    {index < notifications.length - 1 && <Dropdown.Divider />}
                  </React.Fragment>
                ))
              )}
            </>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NotificationComponent;